'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _setImmediate2 = require('babel-runtime/core-js/set-immediate');

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _emailValidator = require('email-validator');

var _emailValidator2 = _interopRequireDefault(_emailValidator);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginBox = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}, (0, _extends3.default)({}, authActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginBox, _Component);

  function LoginBox() {
    (0, _classCallCheck3.default)(this, LoginBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginBox.__proto__ || (0, _getPrototypeOf2.default)(LoginBox)).call(this));

    _this.state = {
      email: null,
      password: null,
      emailError: null,
      passwordError: null,
      loggedIn: false
    };
    return _this;
  }

  (0, _createClass3.default)(LoginBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.auth.token && !this.state.loggedIn) {
        this.setState({ loggedIn: true });

        if (nextProps.onLogin) {
          (0, _setImmediate3.default)(function () {
            nextProps.onLogin();
          });
        }
      }
    }
  }, {
    key: 'onLoginClick',
    value: function onLoginClick(ev) {
      ev.preventDefault();
      ev.stopPropagation();

      if (this.props.loggingIn) return;

      var _state = this.state,
          email = _state.email,
          password = _state.password;


      var emailValid = _emailValidator2.default.validate(email);
      var passwordValid = password.length >= 6;

      if (!emailValid) {
        return this.setState({
          emailError: 'Please enter a valid email address'
        });
      }

      if (!passwordValid) {
        return this.setState({
          passwordError: 'Please make sure that the password is at least 6 characters long.'
        });
      }

      if (emailValid && passwordValid) {
        this.props.login({ email: email, password: password });
      }
    }
  }, {
    key: 'onEmailChange',
    value: function onEmailChange(email) {
      this.setState({ email: email, emailError: null });
    }
  }, {
    key: 'onPasswordChange',
    value: function onPasswordChange(password) {
      this.setState({ password: password, passwordError: null });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _state2 = this.state,
          emailError = _state2.emailError,
          passwordError = _state2.passwordError;
      var naked = this.props.naked;
      var _props$auth = this.props.auth,
          loginError = _props$auth.loginError,
          loggingIn = _props$auth.loggingIn,
          loggedIn = _props$auth.loggedIn;


      var styles = require('./LoginBox.scss');

      var loginBoxClasses = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.LoginBox, true), (0, _defineProperty3.default)(_classnames, styles['LoginBox--naked'], !!naked), _classnames));

      return _react2.default.createElement(
        'div',
        { className: loginBoxClasses },
        !naked && _react2.default.createElement(
          'h2',
          { className: styles['LoginBox__title'] },
          'Sign in with your Quixel account'
        ),
        _react2.default.createElement(
          'form',
          { className: styles['LoginBox__form'] },
          _react2.default.createElement(_components.TextInput, { onChange: this.onEmailChange.bind(this), type: 'email', title: 'Email address' }),
          emailError && _react2.default.createElement(
            'p',
            { className: styles['LoginBox__form-error'] },
            emailError
          ),
          _react2.default.createElement(_components.TextInput, { onChange: this.onPasswordChange.bind(this), type: 'password', title: 'Password' }),
          passwordError && _react2.default.createElement(
            'p',
            { className: styles['LoginBox__form-error'] },
            passwordError
          ),
          loginError && _react2.default.createElement(
            'p',
            { className: styles['LoginBox__error'] },
            'Uh oh! Looks like the email or password is incorrect.',
            loginError.message
          ),
          _react2.default.createElement(_components.Button, {
            className: styles['LoginBox__signin-button'],
            label: loggingIn || loggedIn ? 'Signing in...' : 'Sign in',
            primary: true,
            onClick: this.onLoginClick.bind(this) })
        )
      );
    }
  }]);
  return LoginBox;
}(_react.Component), _class2.propTypes = {
  onLogin: _react2.default.PropTypes.func,
  auth: _react2.default.PropTypes.object.isRequired,
  naked: _react2.default.PropTypes.bool
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object
}, _class2.defaultProps = {
  naked: false
}, _temp)) || _class);
exports.default = LoginBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginBox/LoginBox.jsx
// module id = 2639
// module chunks = 0